import { motion } from "framer-motion";

const STEPS = [
  { key: "vehicle", label: "Vehicle" },
  { key: "journey", label: "Journey" },
  { key: "collection", label: "Collection" },
  { key: "quote", label: "Your Quote" },
  { key: "booking", label: "Secure" },
];

export default function QuoteStepper({ current }) {
  const idx = STEPS.findIndex((s) => s.key === current);
  const pct = ((idx + 1) / STEPS.length) * 100;

  return (
    <div className="sticky top-0 z-30 backdrop-blur-xl bg-black/80 border-b border-white/10" data-testid="quote-stepper">
      <div className="max-w-4xl mx-auto px-6 md:px-10 pt-4 pb-3">
        <div className="flex items-center justify-between mb-3">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold">
            Step {idx + 1} of {STEPS.length}
          </div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-bold">
            {STEPS[idx]?.label}
          </div>
        </div>
        <div className="h-[2px] bg-white/10 relative overflow-hidden">
          <motion.div
            className="absolute inset-y-0 left-0 bg-[#E60000]"
            initial={{ width: 0 }}
            animate={{ width: `${pct}%` }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          />
        </div>
        <div className="hidden md:flex mt-3 gap-4 text-[10px] tracking-[0.2em] uppercase">
          {STEPS.map((s, i) => (
            <div
              key={s.key}
              className={`flex-1 flex items-center gap-2 ${
                i <= idx ? "text-white" : "text-zinc-600"
              }`}
            >
              <span
                className={`w-5 h-5 flex items-center justify-center border text-[10px] font-bold ${
                  i < idx
                    ? "bg-[#E60000] border-[#E60000] text-white"
                    : i === idx
                    ? "border-[#E60000] text-[#E60000]"
                    : "border-white/15 text-zinc-600"
                }`}
              >
                {i < idx ? "✓" : i + 1}
              </span>
              {s.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
